import Base from './base'
import { sortBy } from '../utils'

export default {
  get (year) {
    return Base
      .get(`/year/${year}/makes`)
      .then(res => res.data)
      .then(data => data.sort(sortBy('makeDescription')))
  }
}
